// Catálogo central das chaves nav.* — mapeia prefixo de rota para chave de estatística.
// Um só lugar pra essa lista evita chave divergente entre o tick e o que vira rota nova em App.svelte.
//
// Ordem importa: o primeiro prefixo que bater (com `path === prefixo` ou `path` começando por
// `prefixo + '/'`) é o usado — por isso rotas mais específicas (ex.: /resources/customer-service-v2)
// vêm antes de rotas mais genéricas que também bateriam por prefixo (ex.: /resources).
const NAV_KEYS: { path: string; key: string }[] = [
    { path: '/resources/customer-service-v2', key: 'nav.customer-service-v2' },
    { path: '/customer-service-v2', key: 'nav.customer-service-v2' },
    { path: '/customer-service', key: 'nav.customer-service' },
    { path: '/dashboard', key: 'nav.dashboard' },
    { path: '/agenda', key: 'nav.agenda' },
    { path: '/pos', key: 'nav.pos' },
    { path: '/payments', key: 'nav.payments' },
    { path: '/financial-4', key: 'nav.financial-4' },
    { path: '/financial', key: 'nav.financial' },
    { path: '/automation', key: 'nav.automation' },
    { path: '/referral', key: 'nav.referral' },
    { path: '/customer-balance', key: 'nav.customer-balance' },
    { path: '/nps', key: 'nav.nps' },
    { path: '/tags', key: 'nav.tags' },
    { path: '/pipeline', key: 'nav.pipeline' },
    { path: '/stock-v2', key: 'nav.stock-v2' },
    { path: '/stock', key: 'nav.stock' },
    { path: '/reports-v2', key: 'nav.reports-v2' },
    { path: '/reports', key: 'nav.reports' },
    { path: '/documents', key: 'nav.documents' },
    { path: '/prospect', key: 'nav.prospect' },
    { path: '/tools-scheduler', key: 'nav.tools-scheduler' },
    { path: '/tools-app', key: 'nav.tools-app' },
    { path: '/tools-goalboard', key: 'nav.tools-goalboard' },
    { path: '/resources-lock', key: 'nav.resources-lock' },
    { path: '/comissions', key: 'nav.comissions' },
    { path: '/partners', key: 'nav.partners' },
    { path: '/personalize', key: 'nav.personalize' },
    { path: '/system', key: 'nav.system' },
    { path: '/onboarding', key: 'nav.onboarding' },
    { path: '/resources', key: 'nav.resources' },
]

export function navKeyForPath(path: string): string | null {
    if (!path) return null
    const found = NAV_KEYS.find((el) => path === el.path || path.startsWith(el.path + '/'))
    return found ? found.key : null
}
